import { render, staticRenderFns } from "./DRSTFloatingFooter.vue?vue&type=template&id=cdfe2bd4&"
import script from "./DRSTFloatingFooter.vue?vue&type=script&lang=ts&"
export * from "./DRSTFloatingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTFloatingFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdfe2bd4')) {
      api.createRecord('cdfe2bd4', component.options)
    } else {
      api.reload('cdfe2bd4', component.options)
    }
    module.hot.accept("./DRSTFloatingFooter.vue?vue&type=template&id=cdfe2bd4&", function () {
      api.rerender('cdfe2bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTFloatingFooter.vue"
export default component.exports